import { CSSProperties, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useBackButtonToCloseModal } from '@/hooks/useBackButtonToCloseModal.tsx';
import { InputContent } from '@/components/common/InputContent/InputContent.tsx';

interface ICity {
  label: string;
  translationKey: string;
  available: boolean;
}

const cities: ICity[] = [
  { label: 'Київ', translationKey: 'city_select.kyiv', available: true },
  { label: 'Львів', translationKey: 'city_list.lviv', available: false },
  { label: 'Одеса', translationKey: 'city_list.odesa', available: false },
  { label: 'Харків', translationKey: 'city_list.kharkiv', available: false },
  { label: 'Дніпро', translationKey: 'city_list.dnipro', available: false },
  {
    label: 'Запоріжжя',
    translationKey: 'city_list.zaporizhzhia',
    available: false
  },
  {
    label: 'Кривий Ріг',
    translationKey: 'city_list.kryvyi_rih',
    available: false
  },
  { label: 'Миколаїв', translationKey: 'city_list.mykolaiv', available: false },
  { label: 'Вінниця', translationKey: 'city_list.vinnytsia', available: false },
  { label: 'Полтава', translationKey: 'city_list.poltava', available: false }
];

interface SelectCityPopupProps {
  handleClose: () => void;
}

const SelectCityPopup: FC<SelectCityPopupProps> = ({ handleClose }) => {
  useBackButtonToCloseModal(handleClose, false);
  const { t } = useTranslation();

  return (
    <div style={containerStyle}>
      <InputContent title={t('city_select.label')}>
        <div style={selectedCityItemStyle}>
          <span style={cityLabelStyle}>{t('city_select.kyiv')}</span>
          <span style={checkmarkStyle}>✓</span>
        </div>

        <div style={comingSoonContainerStyle}>
          <div style={citiesListWrapper}>
            {cities.slice(1).map((city) => (
              <div key={city.translationKey} style={disabledCityItemStyle}>
                <span style={blurredCityLabelStyle}>
                  {t(city.translationKey)}
                </span>
              </div>
            ))}
          </div>

          <div style={fadeOverlayStyle} />

          <div style={comingSoonMessageStyle}>{t('city_select.notice')}</div>
        </div>
      </InputContent>
    </div>
  );
};

const containerStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  boxSizing: 'border-box'
};

const selectedCityItemStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '15px 16px',
  backgroundColor: '#fff',
  borderRadius: '12px',
  marginBottom: '12px',
  border: '2px solid #1A1A1A',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.04)'
};

const cityLabelStyle: CSSProperties = {
  fontSize: '15px',
  fontWeight: '500',
  color: '#1A1A1A'
};

const checkmarkStyle: CSSProperties = {
  width: '22px',
  height: '22px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '14px',
  fontWeight: '600',
  color: '#fff',
  backgroundColor: '#1A1A1A',
  borderRadius: '50%'
};

const comingSoonContainerStyle: CSSProperties = {
  position: 'relative',
  borderRadius: '12px',
  overflow: 'hidden'
};

const citiesListWrapper: CSSProperties = {
  backgroundColor: '#fff',
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.04)'
};

const disabledCityItemStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  padding: '15px 16px',
  pointerEvents: 'none'
};

const blurredCityLabelStyle: CSSProperties = {
  fontSize: '15px',
  fontWeight: '400',
  color: '#ccc',
  filter: 'blur(1px)',
  userSelect: 'none'
};

const fadeOverlayStyle: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background:
    'linear-gradient(to bottom, rgba(247,247,248,0) 0%, rgba(247,247,248,0.9) 50%, rgba(247,247,248,0.98) 100%)',
  pointerEvents: 'none',
  borderRadius: '12px'
};

const comingSoonMessageStyle: CSSProperties = {
  position: 'absolute',
  bottom: '50%',
  left: '50%',
  transform: 'translate(-50%, 50%)',
  textAlign: 'center',
  color: '#888',
  fontSize: '14px',
  fontWeight: '500',
  lineHeight: '1.5',
  padding: '0 20px',
  width: '100%',
  boxSizing: 'border-box'
};

export default SelectCityPopup;
